import { Flex, useBreakpointValue } from 'native-base';
import React, { PropsWithChildren } from 'react';

import { Color } from '~/components/color';

export type SidebarProps = PropsWithChildren;

export const Sidebar = (props: SidebarProps) => {
    const { children } = props;

    const isDesktop: boolean = useBreakpointValue({
        base: false,
        md: true
    });

    const sidebarWidth = useBreakpointValue({
        base: 256,
        lg: 312
    });

    return (
        <Flex
            borderRadius="16"
            borderWidth={isDesktop ? 1 : 0}
            borderColor={Color.BORDER_DEFAULT}
            flexDir="column"
            grow={1}
            flexBasis={isDesktop && sidebarWidth}
            maxWidth={sidebarWidth}
            maxHeight="fit-content"
            overflow="hidden"
        >
            {children}
        </Flex>
    );
};
